import { render, staticRenderFns } from "./DSTailArrowLeftIcon.vue?vue&type=template&id=4c442630&"
import script from "./DSTailArrowLeftIcon.vue?vue&type=script&lang=js&"
export * from "./DSTailArrowLeftIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports